import { GetAsync, PostAsync } from "src/common/httpRequests";
import { BUSINESS_ANALYTICS_SERVICE_URL } from "src/constants/api";
import { API_GATEWAY } from "src/constants/settings";

export interface ISurveyStatusResponse {
  shouldShowSurvey: boolean;
  surveyKey: string;
}

export const getSurveyStatus = () =>
  GetAsync(`${API_GATEWAY}${BUSINESS_ANALYTICS_SERVICE_URL}/survey/status`);

export const submitSurvey = (surveyKey: string) =>
  PostAsync(`${API_GATEWAY}${BUSINESS_ANALYTICS_SERVICE_URL}/survey/submit`, {
    surveyKey,
  });
